/* prettier-ignore */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private scrollContainer: any;

  setScrollContainer(container: any): void {
    this.scrollContainer = container;
  }

  scrollToBottom(): void {
    if (this.scrollContainer) {
      try {
        this.scrollContainer.scrollTop = this.scrollContainer.scrollHeight;
      } catch (err) {}
    }
  }

}
